import styled from "styled-components";
export const Container = styled.div<{isAllowMobile?: boolean}>`
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 100px;
  height: 100%;

  h2 {
    font-size: 0.875rem;
    font-weight: 600;
    display: flex;
    gap: 20px;
    .line {
      border: 0.5px solid #333333;
    }
    .option {
      cursor: pointer;
      display: flex;
      align-items: center;
      font-weight: 400;
      
    }
    .year {
      flex: 1;
      text-align: right;
    }
  }

  .no-result {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
